function jsonSchemaToGqlQuery(jsonSchema) {
  const { type, properties, items } = jsonSchema;
  switch (type) {
    case 'string':
    case 'number':
    case 'integer':
    case 'boolean':
      return '';
    case 'object': {
      const fields = Object
        .keys(properties)
        .map(key =>
          !properties[key].displayOnly && ({ key, query: jsonSchemaToGqlQuery(properties[key]) }))
        .map(({ key, query }) => {
          if (properties[key] && properties[key].query) {
            return query ? `${properties[key].query} ${query}` : properties[key].query;
          }
          return query ? `${key} ${query}` : key;
        })
        .join('\n');
      return `{
        ${fields}
        }`;
    }
    case 'array': {
      const query = jsonSchemaToGqlQuery(items);
      return query;
    }
    default:
      throw new Error(`jsonSchemaToGqlQuery unrecognized type: ${type}`);
  }
}

export default jsonSchemaToGqlQuery;



// WEBPACK FOOTER //
// ./src/byob-cms/src/GqlCmsConfigLib/jsonSchemaToGqlQuery.js